// extracted by mini-css-extract-plugin
export default {"customSelect":"custom-select_customSelect__AJYqw","css-olqui2-singleValue":"custom-select_css-olqui2-singleValue__T4VSi"};